<template>

    <v-flex xs12 sm12 md10 lg8 offset-md1 offset-lg2>

        <v-img :src="stepImg"></v-img>

    </v-flex>

</template>

<style scoped>

    .v-image__image--cover {
        background-size: 100% auto !important;
        min-height: 100%;
    }

</style>

<script>

export default {
    props: ["step"],
    data() {
        return {
        }
    },
    computed: {
        stepImg: function() {

            if(this.step) {

                return this.step;

            }

            return '//assets.office4u.xyz/common_asset/stepper/stepper-05.webp';

        }

    }

}
</script>

